import debounce from 'lodash/debounce'
import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { perPageFeedback } from '../../../utils'

const debouncedSearch = debounce(api.activity.getFeedbackList, 300)

const state = {
  title: '',
  qrcode: '',
  signupList: [],
  limitNumber: 0,
  signedUpUserCount: 0,
  signedInCount: 0,
  sessionTimes: [],
  currentSessionTimeId: 0,
  selectedSessionTimeId: '', // 用户选择的场次ID

  currentPage: 1,
  hasMore: true
}

const actions = {
  [aTypes.ACTIVITY_GET_FEEDBACK] ({ commit, dispatch }, id) {
    commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_FEEDBACK, loading: true })
    api.activity.getOne({
      success (res) {
        commit(mTypes.SET_NAV_TITLE, res.body.title)
        commit(mTypes.ACTIVITY_SET_FEEDBACK, { res })
        commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_FEEDBACK, loading: false })
        dispatch(aTypes.ZHUGE_TRACK, { event: '到达活动参与者列表' })
        // 获取活动详情后，自动获取签到统计数据
        dispatch(aTypes.ACTIVITY_GET_SIGNIN_STATISTICS, {
          activityId: id,
          sessionTimeId: res.body.current_session_time_id || undefined
        })
      },
      commit
    }, id)
  },

  [aTypes.ACTIVITY_GET_FEEDBACK_LIST] ({ commit }, { id, page, append, searchName, sessionTimeId }) {
    commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_FEEDBACK_LIST, loading: true })
    const search = searchName ? debouncedSearch : api.activity.getFeedbackList
    search({
      success (res) {
        const list = res.body.data
        const pagination = res.body.meta.pagination
        const hasMore = pagination.current_page < pagination.total_page
        commit(mTypes.ACTIVITY_SET_FEEDBACK_SIGNUPLIST, { list, page, hasMore, append })
        commit(mTypes.SET_LOADED_ID_OF_ACTIVITY_FEEDBACK, id)
        commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_FEEDBACK_LIST, loading: false })
      },
      commit
    }, { id, page, perPage: perPageFeedback, searchName, sessionTimeId })
  },
  [aTypes.ACTIVITY_GET_SIGNIN_STATISTICS] ({ commit }, { activityId, sessionTimeId }) {
    commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_SIGNIN_STATISTICS, loading: true })
    api.activity.getSigninStatistics({
      success (res) {
        commit(mTypes.ACTIVITY_SET_SIGNIN_STATISTICS, { data: res.body.data })
        commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_SIGNIN_STATISTICS, loading: false })
      },
      commit
    }, { activityId, sessionTimeId })
  }
  // [aTypes.ACTIVITY_POST_SIGNIN] ({ commit, dispatch }, { activityId, signupId, index }) {
  //   commit(mTypes.ACTIVITY_SET_FEEDBACK_SIGNLOADING, { index: index, loading: true })
  //   api.activity.postSingin({
  //     success (res) {
  //       commit(mTypes.ACTIVITY_SET_FEEDBACK_SIGNLOADING, { index: index, loading: false })
  //       commit(mTypes.ACTIVITY_SET_FEEDBACK_SIGNLOADED, { index: index })
  //       dispatch(aTypes.ZHUGE_TRACK, { event: '点击签到' })
  //     },
  //     commit
  //   }, { activityId, signupId })
  // }
}

const mutations = {
  [mTypes.ACTIVITY_SET_FEEDBACK] (state, { res }) {
    state.title = res.body.title
    state.qrcode = res.body.short_url
    state.limitNumber = res.body.limit_number_of_user
    // state.signedUpUserCount = res.body.signed_up_user_count
    // state.signedInCount = res.body.signed_in_count
    state.sessionTimes = res.body.session_times
    state.currentSessionTimeId = res.body.current_session_time_id
    state.selectedSessionTimeId = res.body.current_session_time_id
  },
  [mTypes.ACTIVITY_SET_FEEDBACK_SIGNUPLIST] (state, { list, page, hasMore, append }) {
    list.forEach(item => {
      item.loading = false
    })
    if (append) {
      state.signupList = state.signupList.concat(list)
    } else {
      state.signupList = list
    }
    state.currentPage = page
    state.hasMore = hasMore
  },
  [mTypes.ACTIVITY_SET_FEEDBACK_SIGNLOADING] (state, { index, loading }) {
    state.signupList[index].loading = loading
    state.signupList = state.signupList.concat()
  },
  [mTypes.ACTIVITY_SET_FEEDBACK_SIGNLOADED] (state, { index }) {
    state.signupList[index]['signin_count'] = 1
    state.signupList[index]['can_signin'] = false
    state.signupList = state.signupList.concat()
  },
  [mTypes.ACTIVITY_SET_SIGNIN_STATISTICS] (state, { data }) {
    state.signedUpUserCount = data.signed_up_user_count
    state.signedInCount = data.signed_in_count
  },
  [mTypes.ACTIVITY_SET_SELECTED_SESSION_TIME_ID] (state, sessionTimeId) {
    state.selectedSessionTimeId = sessionTimeId
  },
  [mTypes.ACTIVITY_RESET_FEEDBACK] (state) {
    // 重置所有 feedback 相关数据
    state.title = ''
    state.qrcode = ''
    state.signupList = []
    state.limitNumber = 0
    state.signedUpUserCount = 0
    state.signedInCount = 0
    state.sessionTimes = []
    state.currentSessionTimeId = 0
    state.selectedSessionTimeId = ''
    state.currentPage = 1
    state.hasMore = true
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/activity/feedback.js